import { render, staticRenderFns } from "./landingRobotics-michigan.vue?vue&type=template&id=4619d09f&scoped=true&"
import script from "./landingRobotics-michigan.vue?vue&type=script&lang=js&"
export * from "./landingRobotics-michigan.vue?vue&type=script&lang=js&"
import style0 from "./landingRobotics-michigan.vue?vue&type=style&index=0&id=4619d09f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619d09f",
  null
  
)

export default component.exports